export default __webpack_public_path__ + "static/media/sign_up_icon.98c5ab36.png";